module.exports = __webpack_public_path__ + "images/img-aTudlOa.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/1.png
// module id = 2346
// module chunks = 0